function openModal(){
  var modals = document.querySelectorAll('[data-modal="true"]');
  modals.forEach(function (item) {
    item.addEventListener('click', function (e) {
      var target = item;
      e.preventDefault();
      if (target.hasAttribute('data-toggle') && target.getAttribute('data-toggle') === 'modal') {
        if (target.hasAttribute('data-target')) {
          var mID = target.getAttribute('data-target');
          document.getElementById(mID).classList.add('open');
        }
      }
    }, false);
  });
}

/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/product/add-to-cart-modal.js":
/*!*********************************************!*\
  !*** ./src/js/product/add-to-cart-modal.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports) => {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AddToCartModal = AddToCartModal;
function AddToCartModal(variant) {
  var addToCartModalContainer = document.querySelector('#add-to-cart-modal');
  function activateAddToCartModal(modalData) {
    if (addToCartModalContainer) {
      // prod image
      var prodImg = addToCartModalContainer.querySelector('.modal-image img');
      prodImg.setAttribute('src', modalData.image);
      // added Qty
      var addedQty = addToCartModalContainer.querySelector('.add-qty');
      addedQty.innerHTML = modalData.quantity;
      // prod title
      var prodTitle = addToCartModalContainer.querySelector('.product-title');
      prodTitle.innerHTML = modalData.title;
      // prod price
      var prodPrice = addToCartModalContainer.querySelector('.product-price');
      prodPrice.innerHTML = modalData.price;
      // prod variant title
      if (modalData.option !== 'Title') {
        var prodVarTitle = addToCartModalContainer.querySelector('.option-title');
        prodVarTitle.innerHTML = modalData.option;
      }
      // prod variant
      var prodVariant = addToCartModalContainer.querySelector('.selected-option');
      prodVariant.innerHTML = modalData.size;
      // prod Qty
      var prodQty = addToCartModalContainer.querySelector('.prod-qty');
      prodQty.innerHTML = modalData.itemQty;
      // cart Qty
      var cartQty = addToCartModalContainer.querySelector('.total-items-in-cart');
      cartQty.innerHTML = modalData.cart;
      // cart subtotal
      var cartSub = addToCartModalContainer.querySelector('.cart-subtotal-price');
      cartSub.innerHTML = modalData.subtotal;
    }
  }
  function updateCartQuantity(count) {
    var cartLinkBubble = document.querySelector('.header__cart-count');
    if (cartLinkBubble) {
      cartLinkBubble.innerHTML = count;
    }
  }
  var addedItemQuant = '';
  var quantSelect = document.querySelector('input[name="quantity"]');
  if (quantSelect) {
    addedItemQuant = quantSelect.value;
  }
  var formData = {
    items: [{
      id: variant,
      quantity: addedItemQuant
    }]
  };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then(function () {
    fetch('/cart.js').then(function (data) {
      return data.json();
    }).then(function (response) {
      var modalItemImage = '';
      var modalItemVendor = '';
      var modalItemTitle = '';
      var modalItemOption = '';
      var modalItemSize = '';
      var modalItemQuantity = '';
      var modalAddedQuantity = '';
      var modalItemPrice = '';
      var modalCartPrice = '';
      var modalCartCount = '';
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      });
      modalItemImage = response.items[0].image;
      modalItemVendor = response.items[0].vendor;
      modalItemTitle = response.items[0].product_title;
      modalItemOption = response.items[0].options_with_values[0].name;
      modalItemSize = response.items[0].variant_title;
      modalItemQuantity = response.items[0].quantity;
      modalAddedQuantity = addedItemQuant;
      modalItemPrice = formatter.format(response.items[0].price / 100);
      modalCartPrice = formatter.format(response.items_subtotal_price / 100);
      modalCartCount = response.item_count;
      activateAddToCartModal({
        image: modalItemImage,
        vendor: modalItemVendor,
        title: modalItemTitle,
        option: modalItemOption,
        size: modalItemSize,
        quantity: modalAddedQuantity,
        itemQty: modalItemQuantity,
        price: modalItemPrice,
        subtotal: modalCartPrice,
        cart: modalCartCount
      });
      updateCartQuantity(response.item_count);
    });
  }).catch(function (error) {
    console.error('Error: ', error);
  });
  if (typeof item !== 'undefined' && typeof window._learnq !== 'undefined') {
    _learnq.push(['track', 'Added to Cart', item]);
  }
}

/***/ }),

/***/ "./src/js/product/add-to-wishlist.js":
/*!*******************************************!*\
  !*** ./src/js/product/add-to-wishlist.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addToWishlist;
function addToWishlist() {
  var wishListElem = document.querySelector('.product-page__wish-drop .heart');
  var mutTarget = document.querySelector('#main');
  var mutObserver = new MutationObserver(function () {
    if (mutTarget.querySelector('.swym-wishlist-cta')) {
      var wishlistCTA = document.querySelector('.swym-wishlist-cta');
      if (wishlistCTA.textContent.toLowerCase() === 'added to wishlist') {
        wishListElem.style.display = 'none';
      } else {
        wishListElem.style.display = 'flex';
      }
    }
  });
  mutObserver.observe(mutTarget, {
    subtree: true,
    childList: true
  });
  if (wishListElem) {
    wishListElem.addEventListener('click', function () {
      document.querySelector('.swym-wishlist-button-bar button').click();
    });
  }
}

/***/ }),

/***/ "./src/js/product/bangleCustomizer.js":
/*!********************************************!*\
  !*** ./src/js/product/bangleCustomizer.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = bangleCustomizer;
function bangleCustomizer() {
  /* eslint-disable */
  if (!dynamicProduct) return;
  function injectVideo() {
    var videoSection = document.createElement('div');
    videoSection.className = 'video-section';
    var video = document.createElement('video');
    video.setAttribute('width', '100%');
    video.setAttribute('autoplay', 'true');
    video.setAttribute('loop', 'true');
    video.setAttribute('muted', 'true');
    video.setAttribute('playsinline', 'true');
    video.setAttribute('controls', 'true');
    var source = document.createElement('source');
    source.setAttribute('src', 'https://cdn.shopify.com/videos/c/o/v/8794c97938f840c3b88fdd8850304ba4.mp4');
    source.setAttribute('type', 'video/mp4');

    // Assemble the elements
    video.appendChild(source);
    videoSection.appendChild(video);

    // Create and add the text element below the video
    var textElement = document.createElement('p');
    textElement.classList.add('video-info');
    textElement.textContent = 'Scroll to Personalize Your Own Charm Bangle';
    videoSection.appendChild(textElement);

    // Insert the video section before the #dynamic-custom-product element
    var dynamicCustomProduct = document.querySelector('#dynamic-custom-product');
    if (dynamicCustomProduct) {
      dynamicCustomProduct.parentNode.insertBefore(videoSection, dynamicCustomProduct);
    }
  }
  injectVideo();
  var waitForJQ = setInterval(function () {
    if ($) {
      clearInterval(waitForJQ);
      $(document).ready(function () {
        $.ajax({
          url: 'https://shopifyapp.halloweenmakeup.com/front/call_product_mark_jewellers.php',
          data: "product_id=".concat(productID, "&shop_url=").concat(shopDomain),
          dataType: 'json',
          success: function success(json) {
            var left = json.left;
            var right = json.right;
            $('#custom_personalization').html(left);
            $('#right_product').html(right);
          },
          error: function error(jqXHR) {
            console.log(jqXHR);
            alert('Error Loading Custom Options. Please try again later.');
          }
        });
      });
    }
  }, 500);

  /* eslint-enable */

  var waitForImgClass = setInterval(function () {
    if (document.querySelector('.img_dropdown')) {
      clearInterval(waitForImgClass);
      document.querySelectorAll('.img_dropdown').forEach(function (elem) {
        elem.classList.add('img-dropdown');
      });
    }
  }, 500);
  var waitForProcessingClass = setInterval(function () {
    if (document.querySelector('.processing_time')) {
      clearInterval(waitForProcessingClass);
      document.querySelectorAll('.processing_time').forEach(function (elem) {
        elem.classList.add('processing-time');
      });
    }
  }, 500);
  var waitForSwatchClass = setInterval(function () {
    if (document.querySelector('.pplr-swatch-element')) {
      clearInterval(waitForSwatchClass);
      document.querySelectorAll('.pplr-swatch-element').forEach(function (elem) {
        elem.style.zIndex = '1';
      });
    }
  }, 500);
  var waitForReorderText = setInterval(function () {
    if (document.querySelector('.reorder_text')) {
      document.querySelector('.reorder_text').style.display = 'none';
    }
    if (!document.querySelectorAll('#charmBank .item').length) return;
    if (document.querySelector('.reorder_text')) {
      clearInterval(waitForReorderText);
      var newReorderText = document.createElement('div');
      newReorderText.classList.add('new-reorder-text');
      newReorderText.innerHTML = "<div style=\"height:20px;width:20px;margin-right:8px;\"><svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" id=\"Layer_1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 64 64\" enable-background=\"new 0 0 64 64\" xml:space=\"preserve\">\n<g>\n\t<g>\n\t\t<g id=\"XMLID_46_\">\n\t\t\t<g>\n\t\t\t\t<g>\n\t\t\t\t\t<path d=\"M32,64C14.4,64,0,49.6,0,32S14.4,0,32,0s32,14.4,32,32S49.6,64,32,64z M32,4C16.6,4,4,16.6,4,32s12.6,28,28,28       s28-12.6,28-28S47.4,4,32,4z\"/>\n\t\t\t\t</g>\n\t\t\t</g>\n\t\t</g>\n\t</g>\n\t<g>\n\t\t<g>\n\t\t\t<g>\n\t\t\t\t<polygon points=\"29,16 35,16 34,36 30,36     \"/>\n\t\t\t</g>\n\t\t</g>\n\t\t<g>\n\t\t\t<g>\n\t\t\t\t<circle cx=\"32\" cy=\"44\" r=\"4\"/>\n\t\t\t</g>\n\t\t</g>\n\t</g>\n</g>\n</svg></div><div style=\"font-weight: 700\">Drag images to reorder charms</div>";
      document.querySelector('#charmBank').before(newReorderText);
    }
  }, 500);
}

/***/ }),

/***/ "./src/js/product/bangleRedirect.js":
/*!******************************************!*\
  !*** ./src/js/product/bangleRedirect.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = bangleRedirect;
function bangleRedirect() {
  if (window.location.pathname.includes('personalized-skinny-charm-bangle') && window.location.pathname !== '/products/personalized-skinny-charm-bangle-%E2%84%A2') {
    window.location.href = 'https://www.marks-jewelers.com/products/personalized-skinny-charm-bangle-%E2%84%A2';
  }
}

/***/ }),

/***/ "./src/js/product/bread-replacement.js":
/*!*********************************************!*\
  !*** ./src/js/product/bread-replacement.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = breadReplace;
function breadReplace() {
  var waitForContent = setInterval(function () {
    var breadPlacement = document.querySelector('#bread-checkout-btn-product > div > a');
    clearInterval(waitForContent);
    if (breadPlacement) {
      breadPlacement.textContent = "Or ".concat(breadPlacement.textContent.toLowerCase(), " through Bread Pay");
    }
  }, 2300);
}

/***/ }),

/***/ "./src/js/product/customVariantImageSwap.js":
/*!**************************************************!*\
  !*** ./src/js/product/customVariantImageSwap.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = customVariantImageSwap;
function customVariantImageSwap() {
  // updates content in sticky banner to match product variant data
  function stickyMod() {
    var stickyTarget = document.querySelector('.product-sticky-form');
    var stickyObserver = new MutationObserver(function () {
      if (!document.querySelector('.gpo-container')) return;

      // updates sticky header price when any select value is changed
      document.querySelectorAll('.gpo-select select').forEach(function (elem) {
        if (elem.classList.contains('change-applied')) return;
        elem.classList.add('change-applied');
        elem.addEventListener('change', function () {
          var priceTarget = document.querySelector('.product-page__top');
          var priceObserver = new MutationObserver(function () {
            priceObserver.disconnect();
            document.querySelector('.sticky-price').textContent = document.querySelector('.product-page__price').textContent;
          });
          priceObserver.observe(priceTarget, {
            subtree: true,
            childList: true
          });
        });
      });

      // replaces Add To Cart button with one that adds the correct variant items
      if (stickyTarget.querySelector('.sticky-add-cart .btn-add-cart')) {
        if (stickyTarget.querySelector('.sticky-add-cart .btn-add-cart').classList.contains('clone')) {
          return;
        }
        var addToCartButtonClone = document.querySelector('.sticky-add-cart .btn-add-cart');
        var addToCartButton = document.querySelector('.sticky-add-cart .btn-add-cart').cloneNode(true);
        addToCartButtonClone.classList.add('clone');
        addToCartButtonClone.removeAttribute('data-target');
        addToCartButtonClone.removeAttribute('data-toggle');
        addToCartButtonClone.removeAttribute('data-modal');
        addToCartButtonClone.addEventListener('click', function (e) {
          e.preventDefault();
          document.querySelector('.gpo-clone-atc-button').click();
        });
        addToCartButton.after(addToCartButtonClone);
        addToCartButton.remove();
      }
    });
    stickyObserver.observe(stickyTarget, {
      subtree: true,
      childList: true
    });
  }

  // implements custom image swap functionality
  // triggers when a product option selection is made on an item with custom variants
  // currently only supports dropdowns with "change" listeners
  // switch statement utilizes Shopify Product ID as a string
  var target;
  var observer;

  // eslint-disable-next-line no-undef
  switch (productID) {
    // Applies custom image swap function to the item:
    // "M.K. Diamonds & Jewelry Pave Diamond Mini Cuban Link Bracelet"
    case '7839538675934':
      target = document.querySelector('#addToCartForm');
      observer = new MutationObserver(function () {
        if (target.querySelector('select[name="select-metal"]')) {
          observer.disconnect();
          document.querySelector('select[name="select-metal"]').addEventListener('change', function (e) {
            var selectValue = e.target.value;
            var allImages = document.querySelectorAll('.product-page__medias .next-list li img');
            if (selectValue === 'White Gold') allImages[0].click();
            if (selectValue === 'Rose Gold') allImages[2].click();
            if (selectValue === 'Yellow Gold') allImages[4].click();
          });
        }
      });
      observer.observe(target, {
        subtree: true,
        childList: true
      });
      stickyMod();
      break;

    // Applies custom image swap function to the item:
    // "Diamond Initial Pendants in White or Yellow Gold"
    case '7839552438494':
      target = document.querySelector('#addToCartForm');
      observer = new MutationObserver(function () {
        if (target.querySelector('select[name="select-metal"]')) {
          observer.disconnect();
          document.querySelectorAll('select[name="select-metal"], select[name="select-letter"]').forEach(function (elem) {
            return elem.addEventListener('change', function () {
              var metalSelectValue = document.querySelector('select[name="select-metal"]').value;
              var letterSelectValue = document.querySelector('select[name="select-letter"]').value;
              var allImages = document.querySelectorAll('.product-page__medias .next-list li img');
              if (metalSelectValue === 'Yellow Gold') {
                if (letterSelectValue === 'A') allImages[34].click();
                if (letterSelectValue === 'B') allImages[40].click();
                if (letterSelectValue === 'C') allImages[42].click();
                if (letterSelectValue === 'D') allImages[48].click();
                if (letterSelectValue === 'E') allImages[44].click();
                if (letterSelectValue === 'F') allImages[53].click();
                if (letterSelectValue === 'G') allImages[41].click();
                if (letterSelectValue === 'H') allImages[50].click();
                if (letterSelectValue === 'I') allImages[52].click();
                if (letterSelectValue === 'J') allImages[38].click();
                if (letterSelectValue === 'K') allImages[49].click();
                if (letterSelectValue === 'L') allImages[43].click();
                if (letterSelectValue === 'M') allImages[45].click();
                if (letterSelectValue === 'N') allImages[0].click();
                if (letterSelectValue === 'O') allImages[27].click();
                if (letterSelectValue === 'P') allImages[47].click();
                if (letterSelectValue === 'Q') allImages[29].click();
                if (letterSelectValue === 'R') allImages[39].click();
                if (letterSelectValue === 'S') allImages[36].click();
                if (letterSelectValue === 'T') allImages[35].click();
                if (letterSelectValue === 'U') allImages[24].click();
                if (letterSelectValue === 'V') allImages[51].click();
                if (letterSelectValue === 'W') allImages[46].click();
                if (letterSelectValue === 'X') allImages[32].click();
                if (letterSelectValue === 'Y') allImages[56].click();
                if (letterSelectValue === 'Z') allImages[31].click();
              }
              if (metalSelectValue === 'White Gold') {
                if (letterSelectValue === 'A') allImages[10].click();
                if (letterSelectValue === 'B') allImages[11].click();
                if (letterSelectValue === 'C') allImages[5].click();
                if (letterSelectValue === 'D') allImages[3].click();
                if (letterSelectValue === 'E') allImages[7].click();
                if (letterSelectValue === 'F') allImages[20].click();
                if (letterSelectValue === 'G') allImages[13].click();
                if (letterSelectValue === 'H') allImages[18].click();
                if (letterSelectValue === 'I') allImages[19].click();
                if (letterSelectValue === 'J') allImages[9].click();
                if (letterSelectValue === 'K') allImages[2].click();
                if (letterSelectValue === 'L') allImages[8].click();
                if (letterSelectValue === 'M') allImages[1].click();
                if (letterSelectValue === 'N') allImages[16].click();
                if (letterSelectValue === 'O') allImages[26].click();
                if (letterSelectValue === 'P') allImages[4].click();
                if (letterSelectValue === 'Q') allImages[28].click();
                if (letterSelectValue === 'R') allImages[15].click();
                if (letterSelectValue === 'S') allImages[12].click();
                if (letterSelectValue === 'T') allImages[17].click();
                if (letterSelectValue === 'U') allImages[23].click();
                if (letterSelectValue === 'V') allImages[21].click();
                if (letterSelectValue === 'W') allImages[6].click();
                if (letterSelectValue === 'X') allImages[33].click();
                if (letterSelectValue === 'Y') allImages[22].click();
                if (letterSelectValue === 'Z') allImages[30].click();
              }
            });
          });
        }
      });
      observer.observe(target, {
        subtree: true,
        childList: true
      });
      stickyMod();
      break;

    // Applies custom image swap function to the item:
    // "Oval Semi Precious Pendant with Diamond Accents in White Gold"
    case '7874475819230':
      target = document.querySelector('#addToCartForm');
      observer = new MutationObserver(function () {
        if (target.querySelector('select[name="select-birth"]')) {
          observer.disconnect();
          document.querySelector('select[name="select-birth"]').addEventListener('change', function (e) {
            var selectValue = e.target.value;
            var allImages = document.querySelectorAll('.product-page__medias .next-list li img');
            if (selectValue.includes('Aquamarine')) allImages[0].click();
            if (selectValue.includes('Garnet')) allImages[2].click();
            if (selectValue.includes('Citrine')) allImages[3].click();
            if (selectValue.includes('Ruby')) allImages[4].click();
            if (selectValue.includes('Amethyst')) allImages[5].click();
            if (selectValue.includes('Emerald')) allImages[6].click();
            if (selectValue.includes('Opal')) allImages[7].click();
            if (selectValue.includes('Diamond')) allImages[1].click();
            if (selectValue.includes('Alexandrite')) allImages[1].click();
            if (selectValue.includes('Peridot')) allImages[1].click();
            if (selectValue.includes('Sapphire')) allImages[1].click();
            if (selectValue.includes('Blue Topaz')) allImages[1].click();
          });
        }
      });
      observer.observe(target, {
        subtree: true,
        childList: true
      });
      stickyMod();
      break;

    // Applies custom image swap function to the item:
    // "Sterling Silver Diamond Accented and Lab Created Ruby Heart Pendant"
    case '7881324134622':
      target = document.querySelector('#addToCartForm');
      observer = new MutationObserver(function () {
        if (target.querySelector('select[name="select-birth"]')) {
          observer.disconnect();
          document.querySelector('select[name="select-birth"]').addEventListener('change', function (e) {
            var selectValue = e.target.value;
            var allImages = document.querySelectorAll('.product-page__medias .next-list li img');
            if (selectValue.includes('Diamond')) allImages[1].click();
            if (selectValue.includes('Opal')) allImages[2].click();
            if (selectValue.includes('Emerald')) allImages[3].click();
            if (selectValue.includes('Sapphire')) allImages[4].click();
            if (selectValue.includes('Garnet')) allImages[5].click();
            if (selectValue.includes('Amethyst')) allImages[6].click();
            if (selectValue.includes('Citrine')) allImages[7].click();
            if (selectValue.includes('Aquamarine')) allImages[9].click();
            if (selectValue.includes('Opal')) allImages[10].click();
            if (selectValue.includes('Peridot')) allImages[11].click();
            if (selectValue.includes('Ruby')) allImages[12].click();
            if (selectValue.includes('Alexandrite')) allImages[0].click();
            if (selectValue.includes('Blue Topaz')) allImages[0].click();
          });
        }
      });
      observer.observe(target, {
        subtree: true,
        childList: true
      });
      stickyMod();
      break;

    // Applies custom image swap function to the item:
    // "Round Amethyst 0.65 ct & Diamond Halo 0.10 ctw Twist Ring in Sterling Silver"
    case '7876417716446':
      target = document.querySelector('#addToCartForm');
      observer = new MutationObserver(function () {
        if (target.querySelector('select[name="select-birth"]')) {
          observer.disconnect();
          document.querySelector('select[name="select-birth"]').addEventListener('change', function (e) {
            var selectValue = e.target.value;
            var allImages = document.querySelectorAll('.product-page__medias .next-list li img');
            if (selectValue.includes('Garnet')) allImages[0].click();
            if (selectValue.includes('Ruby')) allImages[0].click();
            if (selectValue.includes('Amethyst')) allImages[1].click();
            if (selectValue.includes('Aquamarine')) allImages[2].click();
            if (selectValue.includes('Diamond')) allImages[3].click();
            if (selectValue.includes('Pearl')) allImages[4].click();
            if (selectValue.includes('Emerald')) allImages[5].click();
            if (selectValue.includes('Alexandrite')) allImages[6].click();
            if (selectValue.includes('Peridot')) allImages[7].click();
            if (selectValue.includes('Sapphire')) allImages[8].click();
            if (selectValue.includes('Opal')) allImages[9].click();
            if (selectValue.includes('Citrine')) allImages[10].click();
            if (selectValue.includes('Blue Topaz')) allImages[11].click();
            if (selectValue.includes('Ruby')) allImages[0].click();
          });
        }
      });
      observer.observe(target, {
        subtree: true,
        childList: true
      });
      stickyMod();
      break;

    // Applies custom image swap function to the item:
    // "Round Amethyst 5.2 mm & Diamond Halo 0.16 ctw Earrings in Sterling Silver"
    case '7876490887390':
      target = document.querySelector('#addToCartForm');
      observer = new MutationObserver(function () {
        if (target.querySelector('select[name="select-birth"]')) {
          observer.disconnect();
          document.querySelector('select[name="select-birth"]').addEventListener('change', function (e) {
            var selectValue = e.target.value;
            var allImages = document.querySelectorAll('.product-page__medias .next-list li img');
            if (selectValue.includes('Garnet')) allImages[2].click();
            if (selectValue.includes('Amethyst')) allImages[0].click();
            if (selectValue.includes('Citrine')) allImages[1].click();
            if (selectValue.includes('Ruby')) allImages[2].click();
            if (selectValue.includes('Aquamarine')) allImages[3].click();
            if (selectValue.includes('Diamond')) allImages[4].click();
            if (selectValue.includes('Peridot')) allImages[5].click();
            if (selectValue.includes('Pearl')) allImages[6].click();
            if (selectValue.includes('Blue Topaz')) allImages[7].click();
          });
        }
      });
      observer.observe(target, {
        subtree: true,
        childList: true
      });
      stickyMod();
      break;

    // Applies custom image swap function to the item:
    // "Diamond 0.04 ctw Halo Pendants in White Gold"
    case '7876511334622':
      target = document.querySelector('#addToCartForm');
      observer = new MutationObserver(function () {
        if (target.querySelector('select[name="select-center-type"]')) {
          observer.disconnect();
          document.querySelector('select[name="select-center-type"]').addEventListener('change', function (e) {
            var selectValue = e.target.value;
            var allImages = document.querySelectorAll('.product-page__medias .next-list li img');
            if (selectValue.includes('Sapphire')) allImages[2].click();
            if (selectValue.includes('Ruby')) allImages[1].click();
            if (selectValue.includes('Emerald')) allImages[0].click();
          });
        }
      });
      observer.observe(target, {
        subtree: true,
        childList: true
      });
      stickyMod();
      break;

    // Applies custom image swap function to the item:
    // "10K Diamond And Gemstone Mixable & Stackable Rings (Channel)"
    case '7838412144862':
      target = document.querySelector('#addToCartForm');
      observer = new MutationObserver(function () {
        if (target.querySelector('select[name="select-material"]')) {
          observer.disconnect();
          document.querySelectorAll('select[name="select-material"], select[name="select-color"]').forEach(function (elem) {
            return elem.addEventListener('change', function () {
              var materialSelectValue = document.querySelector('select[name="select-material"]').value;
              var colorSelectValue = document.querySelector('select[name="select-color"]').value;
              var allImages = document.querySelectorAll('.product-page__medias .next-list li img');
              if (materialSelectValue === '10K Yellow Gold') {
                if (colorSelectValue === 'Garnet') allImages[11].click();
                if (colorSelectValue === 'Amethyst') allImages[12].click();
                if (colorSelectValue === 'Emerald') allImages[13].click();
                if (colorSelectValue === 'Sapphire') allImages[15].click();
                if (colorSelectValue === 'Synthetic Alexandrite') allImages[16].click();
                if (colorSelectValue === 'Peridot') allImages[17].click();
                if (colorSelectValue === 'Pink Sapphire') allImages[18].click();
                if (colorSelectValue === 'Pink Tourmaline') allImages[19].click();
                if (colorSelectValue === 'Citrine') allImages[20].click();
                if (colorSelectValue === 'Aquamarine') allImages[21].click();
                if (colorSelectValue === 'Ruby') allImages[11].click();
                if (colorSelectValue === 'Blue Topaz') allImages[15].click();
              }
              if (materialSelectValue === '10K White Gold') {
                if (colorSelectValue === 'Garnet') allImages[0].click();
                if (colorSelectValue === 'Amethyst') allImages[1].click();
                if (colorSelectValue === 'Emerald') allImages[2].click();
                if (colorSelectValue === 'Sapphire') allImages[4].click();
                if (colorSelectValue === 'Synthetic Alexandrite') allImages[5].click();
                if (colorSelectValue === 'Peridot') allImages[6].click();
                if (colorSelectValue === 'Pink Sapphire') allImages[7].click();
                if (colorSelectValue === 'Pink Tourmaline') allImages[8].click();
                if (colorSelectValue === 'Citrine') allImages[9].click();
                if (colorSelectValue === 'Aquamarine') allImages[10].click();
                if (colorSelectValue === 'Ruby') allImages[0].click();
                if (colorSelectValue === 'Blue Topaz') allImages[4].click();
              }
              if (materialSelectValue === '10K Rose Gold') {
                if (colorSelectValue === 'Garnet') allImages[22].click();
                if (colorSelectValue === 'Amethyst') allImages[23].click();
                if (colorSelectValue === 'Emerald') allImages[25].click();
                if (colorSelectValue === 'Sapphire') allImages[27].click();
                if (colorSelectValue === 'Synthetic Alexandrite') allImages[28].click();
                if (colorSelectValue === 'Peridot') allImages[29].click();
                if (colorSelectValue === 'Pink Sapphire') allImages[30].click();
                if (colorSelectValue === 'Pink Tourmaline') allImages[31].click();
                if (colorSelectValue === 'Citrine') allImages[32].click();
                if (colorSelectValue === 'Aquamarine') allImages[33].click();
                if (colorSelectValue === 'Ruby') allImages[22].click();
                if (colorSelectValue === 'Blue Topaz') allImages[27].click();
              }
            });
          });
        }
      });
      observer.observe(target, {
        subtree: true,
        childList: true
      });
      stickyMod();
      break;

    // Applies custom image swap function to the item:
    // "10K Diamond And Gemstone Mixable & Stackable Rings (Diamond)"
    case '7838533681374':
      target = document.querySelector('#addToCartForm');
      observer = new MutationObserver(function () {
        if (target.querySelector('select[name="select-material"]')) {
          observer.disconnect();
          document.querySelectorAll('select[name="select-material"], select[name="select-color"]').forEach(function (elem) {
            return elem.addEventListener('change', function () {
              var materialSelectValue = document.querySelector('select[name="select-material"]').value;
              var colorSelectValue = document.querySelector('select[name="select-color"]').value;
              var allImages = document.querySelectorAll('.product-page__medias .next-list li img');
              if (materialSelectValue === '10K Yellow Gold') {
                if (colorSelectValue === 'Amethyst') allImages[12].click();
                if (colorSelectValue === 'Emerald') allImages[13].click();
                if (colorSelectValue === 'Sapphire') allImages[14].click();
                if (colorSelectValue === 'Synthetic Alexandrite') allImages[15].click();
                if (colorSelectValue === 'Peridot') allImages[16].click();
                if (colorSelectValue === 'Pink Sapphire') allImages[17].click();
                if (colorSelectValue === 'Pink Tourmaline') allImages[18].click();
                if (colorSelectValue === 'Citrine') allImages[19].click();
                if (colorSelectValue === 'Aquamarine') allImages[20].click();
                if (colorSelectValue === 'Garnet') allImages[15].click();
                if (colorSelectValue === 'Ruby') allImages[15].click();
                if (colorSelectValue === 'Blue Topaz') allImages[14].click();
              }
              if (materialSelectValue === '10K White Gold') {
                if (colorSelectValue === 'Garnet') allImages[0].click();
                if (colorSelectValue === 'Amethyst') allImages[1].click();
                if (colorSelectValue === 'Emerald') allImages[2].click();
                if (colorSelectValue === 'Sapphire') allImages[3].click();
                if (colorSelectValue === 'Synthetic Alexandrite') allImages[4].click();
                if (colorSelectValue === 'Peridot') allImages[5].click();
                if (colorSelectValue === 'Pink Sapphire') allImages[6].click();
                if (colorSelectValue === 'Pink Tourmaline') allImages[7].click();
                if (colorSelectValue === 'Citrine') allImages[8].click();
                if (colorSelectValue === 'Aquamarine') allImages[10].click();
                if (colorSelectValue === 'Ruby') allImages[11].click();
                if (colorSelectValue === 'Blue Topaz') allImages[3].click();
              }
              if (materialSelectValue === '10K Rose Gold') {
                if (colorSelectValue === 'Garnet') allImages[21].click();
                if (colorSelectValue === 'Amethyst') allImages[22].click();
                if (colorSelectValue === 'Emerald') allImages[23].click();
                if (colorSelectValue === 'Sapphire') allImages[24].click();
                if (colorSelectValue === 'Synthetic Alexandrite') allImages[25].click();
                if (colorSelectValue === 'Peridot') allImages[26].click();
                if (colorSelectValue === 'Pink Sapphire') allImages[27].click();
                if (colorSelectValue === 'Pink Tourmaline') allImages[27].click();
                if (colorSelectValue === 'Citrine') allImages[28].click();
                if (colorSelectValue === 'Aquamarine') allImages[29].click();
                if (colorSelectValue === 'Ruby') allImages[21].click();
                if (colorSelectValue === 'Blue Topaz') allImages[24].click();
              }
            });
          });
        }
      });
      observer.observe(target, {
        subtree: true,
        childList: true
      });
      stickyMod();
      break;

    // Applies custom image swap function to the item:
    // "10K Diamond And Gemstone Mixable & Stackable Rings (Hearts)"
    case '7838289494238':
      target = document.querySelector('#addToCartForm');
      observer = new MutationObserver(function () {
        if (target.querySelector('select[name="material-select"]')) {
          observer.disconnect();
          document.querySelectorAll('select[name="material-select"], select[name="gemstone-select"]').forEach(function (elem) {
            return elem.addEventListener('change', function () {
              var materialSelectValue = document.querySelector('select[name="material-select"]').value;
              var colorSelectValue = document.querySelector('select[name="gemstone-select"]').value;
              var allImages = document.querySelectorAll('.product-page__medias .next-list li img');
              if (materialSelectValue === '10K Yellow Gold') {
                if (colorSelectValue === 'Garnet') allImages[14].click();
                if (colorSelectValue === 'Amethyst') allImages[15].click();
                if (colorSelectValue === 'Emerald') allImages[16].click();
                if (colorSelectValue === 'Sapphire') allImages[17].click();
                if (colorSelectValue === 'Synthetic Alexandrite') allImages[18].click();
                if (colorSelectValue === 'Peridot') allImages[19].click();
                if (colorSelectValue === 'Pink Sapphire') allImages[20].click();
                if (colorSelectValue === 'Pink Tourmaline') allImages[21].click();
                if (colorSelectValue === 'Citrine') allImages[22].click();
                if (colorSelectValue === 'Aquamarine') allImages[23].click();
                if (colorSelectValue === 'Ruby') allImages[24].click();
                if (colorSelectValue === 'Blue Topaz') allImages[17].click();
              }
              if (materialSelectValue === '10K White Gold') {
                if (colorSelectValue === 'Garnet') allImages[0].click();
                if (colorSelectValue === 'Amethyst') allImages[2].click();
                if (colorSelectValue === 'Emerald') allImages[3].click();
                if (colorSelectValue === 'Sapphire') allImages[4].click();
                if (colorSelectValue === 'Synthetic Alexandrite') allImages[5].click();
                if (colorSelectValue === 'Peridot') allImages[6].click();
                if (colorSelectValue === 'Pink Sapphire') allImages[7].click();
                if (colorSelectValue === 'Pink Tourmaline') allImages[8].click();
                if (colorSelectValue === 'Citrine') allImages[9].click();
                if (colorSelectValue === 'Aquamarine') allImages[10].click();
                if (colorSelectValue === 'Ruby') allImages[11].click();
                if (colorSelectValue === 'Blue Topaz') allImages[4].click();
              }
              if (materialSelectValue === '10K Rose Gold') {
                if (colorSelectValue === 'Garnet') allImages[25].click();
                if (colorSelectValue === 'Amethyst') allImages[26].click();
                if (colorSelectValue === 'Emerald') allImages[28].click();
                if (colorSelectValue === 'Sapphire') allImages[29].click();
                if (colorSelectValue === 'Synthetic Alexandrite') allImages[30].click();
                if (colorSelectValue === 'Peridot') allImages[31].click();
                if (colorSelectValue === 'Pink Sapphire') allImages[32].click();
                if (colorSelectValue === 'Pink Tourmaline') allImages[33].click();
                if (colorSelectValue === 'Citrine') allImages[34].click();
                if (colorSelectValue === 'Aquamarine') allImages[35].click();
                if (colorSelectValue === 'Ruby') allImages[36].click();
                if (colorSelectValue === 'Blue Topaz') allImages[29].click();
              }
            });
          });
        }
      });
      observer.observe(target, {
        subtree: true,
        childList: true
      });
      stickyMod();
      break;

    // Applies custom image swap function to the item:
    // "10K Diamond And Gemstone Mixable & Stackable Rings (Square)"
    case '7838516052190':
      target = document.querySelector('#addToCartForm');
      observer = new MutationObserver(function () {
        if (target.querySelector('select[name="material-select"]')) {
          observer.disconnect();
          document.querySelectorAll('select[name="material-select"], select[name="gemstone-select"]').forEach(function (elem) {
            return elem.addEventListener('change', function () {
              var materialSelectValue = document.querySelector('select[name="material-select"]').value;
              var colorSelectValue = document.querySelector('select[name="gemstone-select"]').value;
              var allImages = document.querySelectorAll('.product-page__medias .next-list li img');
              if (materialSelectValue === '10K Yellow Gold') {
                if (colorSelectValue === 'Garnet') allImages[11].click();
                if (colorSelectValue === 'Amethyst') allImages[12].click();
                if (colorSelectValue === 'Emerald') allImages[13].click();
                if (colorSelectValue === 'Sapphire') allImages[15].click();
                if (colorSelectValue === 'Synthetic Alexandrite') allImages[16].click();
                if (colorSelectValue === 'Peridot') allImages[17].click();
                if (colorSelectValue === 'Pink Sapphire') allImages[18].click();
                if (colorSelectValue === 'Pink Tourmaline') allImages[18].click();
                if (colorSelectValue === 'Citrine') allImages[19].click();
                if (colorSelectValue === 'Aquamarine') allImages[20].click();
                if (colorSelectValue === 'Ruby') allImages[11].click();
                if (colorSelectValue === 'Blue Topaz') allImages[15].click();
              }
              if (materialSelectValue === '10K White Gold') {
                if (colorSelectValue === 'Garnet') allImages[0].click();
                if (colorSelectValue === 'Amethyst') allImages[1].click();
                if (colorSelectValue === 'Emerald') allImages[2].click();
                if (colorSelectValue === 'Sapphire') allImages[4].click();
                if (colorSelectValue === 'Synthetic Alexandrite') allImages[5].click();
                if (colorSelectValue === 'Peridot') allImages[6].click();
                if (colorSelectValue === 'Pink Sapphire') allImages[7].click();
                if (colorSelectValue === 'Pink Tourmaline') allImages[8].click();
                if (colorSelectValue === 'Citrine') allImages[9].click();
                if (colorSelectValue === 'Aquamarine') allImages[10].click();
                if (colorSelectValue === 'Ruby') allImages[0].click();
                if (colorSelectValue === 'Blue Topaz') allImages[4].click();
              }
              if (materialSelectValue === '10K Rose Gold') {
                if (colorSelectValue === 'Garnet') allImages[21].click();
                if (colorSelectValue === 'Amethyst') allImages[22].click();
                if (colorSelectValue === 'Emerald') allImages[23].click();
                if (colorSelectValue === 'Sapphire') allImages[25].click();
                if (colorSelectValue === 'Synthetic Alexandrite') allImages[26].click();
                if (colorSelectValue === 'Peridot') allImages[27].click();
                if (colorSelectValue === 'Pink Sapphire') allImages[28].click();
                if (colorSelectValue === 'Pink Tourmaline') allImages[28].click();
                if (colorSelectValue === 'Citrine') allImages[29].click();
                if (colorSelectValue === 'Aquamarine') allImages[30].click();
                if (colorSelectValue === 'Ruby') allImages[21].click();
                if (colorSelectValue === 'Blue Topaz') allImages[25].click();
              }
            });
          });
        }
      });
      observer.observe(target, {
        subtree: true,
        childList: true
      });
      stickyMod();
      break;
    // END OF DECLARED CASES
    default:
      stickyMod();
  }
}

/***/ }),

/***/ "./src/js/product/globo-recommendations.js":
/*!*************************************************!*\
  !*** ./src/js/product/globo-recommendations.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports) => {



function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = globoRecommendations;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function globoRecommendations() {
  // Creating product recommendation container
  var relatedProductsContainerMarkup = "\n    <div class=\"container container--lg padding-y-sm padding-y-lg@lg recommended-products is-hidden\">\n        <h2 class=\"merchandising-header\">Other Products You'll Love</h2>\n        <ul class=\"recommended-products__items--container\"></ul>\n    </div>\n  ";

  // Placing product recommendation container
  document.querySelector('.product-page.container').insertAdjacentHTML('afterend', relatedProductsContainerMarkup);

  // Observes original "Globo Recommendations" element generated by Globo Shopify App
  var recommendationTarget = document.querySelector('.globoRecommendationsBottom');
  var recommendationObserver = new MutationObserver(function () {
    if (recommendationTarget.querySelector('.gowl-item')) {
      recommendationObserver.disconnect();

      // Iterates through first four items found in the original "Globo Recommendations" element
      document.querySelectorAll('.gowl-item').forEach( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(elem, i) {
          var elemID, elemLink, elemImage, elemTitle, elemPrice, elemVariantID, elemCartLink, newRecommendedProductMarkup;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(i <= 3)) {
                  _context.next = 7;
                  break;
                }
                // Gets product ID from original "Globo Recommendations" item element
                elemID = elem.querySelector('li').getAttribute('data-product-id'); // Gets product handle from original "Globo Recommendations" item element
                elemLink = elem.querySelector('a').getAttribute('href');
                _context.next = 5;
                return fetch("https://www.marks-jewelers.com".concat(elemLink, ".json")).then(function (res) {
                  return res.json();
                }).then(function (data) {
                  var productInfo = data.product;
                  var elemVariant = productInfo.variants[0];

                  // Uses main image found in item data, or a default placeholder image
                  if (productInfo.image && productInfo.image.src) {
                    elemImage = productInfo.image.src;
                  } else {
                    elemImage = '//cdn.shopify.com/s/files/1/0608/9752/5982/t/125/assets/placeholder.jpg?v=151154208444741004661661359290';
                  }

                  // Sets values from item data
                  elemTitle = productInfo.title;
                  elemPrice = "$".concat(elemVariant.price);
                  elemVariantID = elemVariant.id;
                  elemCartLink = "/cart/add/".concat(elemVariantID);
                });
              case 5:
                // Creates markup for new product recommendation element based on item data
                newRecommendedProductMarkup = "\n              <li class=\"recommended-products__item\" data-product-id=\"".concat(elemID, "\" data-variant-id=\"").concat(elemVariantID, "\">\n                  <a class=\"recommended-products__item--link\" href=").concat(elemLink, ">\n                      <div class=\"recommended-products__image\" style=\"background-image: url(").concat(elemImage, ")\"></div>\n                      <h3 class=\"recommended-products__title\">").concat(elemTitle, "</h3>\n                  </a>\n                  <p class=\"recommended-products__price\">From: ").concat(elemPrice, "</p>\n                  <a class=\"btn\" href=").concat(elemCartLink, ">Add to cart</a>\n              </li>\n            "); // Places markup for new product recommendation element
                document.querySelector('.recommended-products__items--container').insertAdjacentHTML('beforeend', newRecommendedProductMarkup);
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());

      // Displays new Product Recommendation element after item data has been populated
      document.querySelector('.recommended-products.container').classList.remove('is-hidden');

      // Removes "Globo" recommendation elements that were generated by the app
      document.querySelector('.globoRecommendationsTop').remove();
      document.querySelector('.globoRecommendationsBottom').remove();
    }
  });
  recommendationObserver.observe(recommendationTarget, {
    subtree: true,
    childList: true
  });
}

/***/ }),

/***/ "./src/js/product/imagePanZoom.js":
/*!****************************************!*\
  !*** ./src/js/product/imagePanZoom.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = imagePanZoom;
function imagePanZoom() {
  var mainImageContainer = document.querySelector('.product-page__medias .top-container .main-image-container');
  mainImageContainer.addEventListener('mousemove', function (e) {
    var parentImageContainer = e.target.closest('.main-image-container');
    var currentImage = parentImageContainer.querySelector('.current-image');

    // Gets information about the position of the element.
    var dimensions = parentImageContainer.getBoundingClientRect();

    // Calculates position of cursor inside the element
    var x = e.clientX - dimensions.left;
    var y = e.clientY - dimensions.top;

    // Calculates position of cursor as percentage of width/height of element
    var xPercent = Math.round(100 / (dimensions.width / x)) * 2 - 100;
    var yPercent = Math.round(100 / (dimensions.height / y)) * 2 - 100;

    // Prevents panning too far
    if (xPercent > 35) xPercent = 35;
    if (xPercent < -35) xPercent = -35;
    if (yPercent > 25) yPercent = 25;
    if (yPercent < -25) yPercent = -25;
    currentImage.style.transform = "scale(2) translate(".concat(xPercent * -1, "%, ").concat(yPercent * -1, "%)");
  });
  mainImageContainer.addEventListener('mouseleave', function (e) {
    var parentImageContainer = e.target.closest('.main-image-container');
    var currentImage = parentImageContainer.querySelector('.current-image');
    currentImage.removeAttribute('style');
  });
}

/***/ }),

/***/ "./src/js/product/klaviyo-form.js":
/*!****************************************!*\
  !*** ./src/js/product/klaviyo-form.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = klaviyoForm;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function klaviyoForm() {
  var emailProdName = document.querySelector('.product-page__title h1').textContent;
  var emailProdUrl = window.location.href;
  var emailProdImg = document.querySelector('.main-image-container img').getAttribute('src');
  var emailProdPrice = document.querySelector('.product-page__price').textContent;
  var form = document.querySelector('#email_hint_it_signup');
  var klaviyoWait = setInterval(function () {
    if ((typeof KlaviyoSubscribe === "undefined" ? "undefined" : _typeof(KlaviyoSubscribe)) === 'object' && form) {
      clearInterval(klaviyoWait);
      /* eslint-disable */
      KlaviyoSubscribe.attachToForms('#email_hint_it_signup', {
        hide_form_on_success: true,
        extra_properties: {
          $source: 'Hint It',
          $method_type: 'Klaviyo Form',
          $method_id: 'embed - Hint It',
          success_message: 'Thank you for sharing!',
          success: function success($form) {
            // `$form` is a jQuery wrapper around the form that was submitted.
            // This makes it easy to get the email address or form fields.
            var email = $('#email_hint_it_signup').find('[name="email"]').val();
            _learnq.push(['identify', {
              $email: email
            }]);
            var SenderName = $('#email_hint_it_signup').find('#k_id_SenderName').val();
            var SenderEmail = $('#email_hint_it_signup').find('#k_id_SenderEmail').val();
            _learnq.push(['track', 'Hint It Submision', {
              SenderName: SenderName,
              SenderEmail: SenderEmail,
              ProductName: emailProdName,
              ProductImageURL: emailProdImg,
              ProductUrl: emailProdUrl,
              Price: emailProdPrice
            }]);
            // Re identify sender
            _learnq.push(['identify', {
              $email: SenderEmail
            }]);
            // Hide the other messages and show ours.
            $('#email_hint_it_signup').addClass('hidden');
            // Show our message
            $('.ti-success-msg').removeClass('hidden');
            // move down the form on success
            $('.ti-drop-hint').addClass('success');
          }
        }
      });
      /* eslint-enable */
    }
  }, 100);
}

/***/ }),

/***/ "./src/js/product/modal-triggers.js":
/*!******************************************!*\
  !*** ./src/js/product/modal-triggers.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = modalTriggers;
var _addToCartModal = __webpack_require__(/*! ./add-to-cart-modal */ "./src/js/product/add-to-cart-modal.js");
function modalTriggers() {
  var modals = document.querySelectorAll('[data-modal="true"]');
  modals.forEach(function (item) {
    item.addEventListener('click', function (e) {
      var variantId;
      var target = item;
      e.preventDefault();
      if (target.hasAttribute('data-toggle') && target.getAttribute('data-toggle') === 'modal') {
        if (target.hasAttribute('data-target')) {
          var mID = target.getAttribute('data-target');
          if (target.classList.contains('btn-add-cart')) {
            if (document.querySelector('.product-options')) {
              variantId = document.querySelector('.product-options').value;
            } else {
              var variantIdDiv = document.querySelector('.product-page__single-variant');
              variantId = variantIdDiv.getAttribute('data-value');
            }
            (0, _addToCartModal.AddToCartModal)(variantId);
            setTimeout(function () {
              document.getElementById(mID).classList.add('open');
            }, 1000);
          } else {
            document.getElementById(mID).classList.add('open');
          }
        }
      }
      // Close modal window with 'data-dismiss' attribute or when the overlay is clicked
      if (target.hasAttribute('data-dismiss') && target.getAttribute('data-dismiss') === 'modal' || target.classList.contains('modals')) {
        var modal = document.querySelector('[class="modals open"]');
        modal.classList.remove('open');
      }
    }, false);
  });
}

/***/ }),

/***/ "./src/js/product/product-carousel.js":
/*!********************************************!*\
  !*** ./src/js/product/product-carousel.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = productCarousel;
function carouselize(carousel) {
  var carouselContainer = carousel;
  var listImageArea = carouselContainer.querySelector('.next-list');
  var listOfImages = listImageArea.querySelectorAll('img');
  var currentImage = carouselContainer.querySelector('.current-image');
  var arrowLeft = carouselContainer.querySelector('.arrow-left');
  var arrowRight = carouselContainer.querySelector('.arrow-right');
  var mainContainer = carouselContainer.querySelector('.top-container');
  var mainImageContainer = carouselContainer.querySelector('.main-image-container');

  // add current to first list item
  var current = listOfImages[0];
  var lastElement = listOfImages[listOfImages.length - 1];
  current.classList.add('current-image-list');
  if (listOfImages.length > 1) {
    mainContainer.addEventListener('mouseenter', function (e) {
      arrowLeft.style.visibility = 'visible';
      arrowRight.style.visibility = 'visible';
    });
    mainContainer.addEventListener('mouseleave', function (e) {
      arrowLeft.style.visibility = 'hidden';
      arrowRight.style.visibility = 'hidden';
    });
  }
  function goToRight() {
    current = listImageArea.querySelector('.current-image-list');
    current.parentElement.nextElementSibling.children[0].classList.add('current-image-list');
    current.classList.remove('current-image-list');
    current = listImageArea.querySelector('.current-image-list');
    listImageArea.scrollLeft = current.offsetLeft;

    var mainMedia = mainImageContainer.querySelector('.main-media');
    var preloadMedia = current.nextElementSibling.querySelector('.main-media').cloneNode(true);
    mainImageContainer.replaceChild(preloadMedia, mainMedia);
    openModal();

    currentImage.classList.add('slideInFromRight');
    setTimeout(function () {
      if (current === lastElement) {
        arrowRight.classList.add('disabled');
        arrowLeft.classList.remove('disabled');
      }
      currentImage.classList.remove('slideInFromRight');
    }, 500);
  }
  function goToLeft() {
    current = listImageArea.querySelector('.current-image-list');
    current.parentElement.previousElementSibling.children[0].classList.add('current-image-list');
    current.classList.remove('current-image-list');
    current = listImageArea.querySelector('.current-image-list');
    listImageArea.scrollLeft = current.offsetLeft;

    var mainMedia = mainImageContainer.querySelector('.main-media');
    var preloadMedia = current.nextElementSibling.querySelector('.main-media').cloneNode(true);
    mainImageContainer.replaceChild(preloadMedia, mainMedia);
    openModal();

    currentImage.classList.add('slideInFromLeft');
    setTimeout(function () {
      if (current === listOfImages[0]) {
        arrowLeft.classList.add('disabled');
        arrowRight.classList.remove('disabled');
      }
      currentImage.classList.remove('slideInFromLeft');
    }, 500);
  }
  function changeCurrentImage(newImage) {
    var mainMedia = mainImageContainer.querySelector('.main-media');
    var preloadMedia = this.nextElementSibling.querySelector('.main-media').cloneNode(true);
    mainImageContainer.replaceChild(preloadMedia, mainMedia);
    openModal();

    preloadMedia.classList.add('fadeIn');
    setTimeout(function () {
      preloadMedia.classList.remove('fadeIn');
    }, 500);

    listOfImages.forEach(function (image) {
      image.classList.remove('current-image-list');
    });
    this.classList.add('current-image-list');
    current = listImageArea.querySelector('.current-image-list');
    if (current === lastElement) {
      arrowRight.classList.add('disabled');
      arrowLeft.classList.remove('disabled');
    }
    if (current === listOfImages[0]) {
      arrowLeft.classList.add('disabled');
      arrowRight.classList.remove('disabled');
    }
  }
  arrowLeft.addEventListener('click', function (e) {
    goToLeft();
  });
  arrowRight.addEventListener('click', function (e) {
    goToRight();
  });
  (function setProto() {
    if (typeof NodeList.prototype.forEach === 'function') return false;
    NodeList.prototype.forEach = Array.prototype.forEach;
  })();
  listOfImages.forEach(function (image) {
    return image.addEventListener('click', changeCurrentImage);
  });
}
function productCarousel() {
  var carousels = document.querySelectorAll('.carousel-container');
  [].forEach.call(carousels, function (carousel) {
    carouselize(carousel);
  });
}

/***/ }),

/***/ "./src/js/product/remove-usp-from-handbags.js":
/*!****************************************************!*\
  !*** ./src/js/product/remove-usp-from-handbags.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = removeUspFromHandbags;
function removeUspFromHandbags() {
  // eslint-disable-next-line no-undef
  if (productType.toLowerCase() === 'luxury handbags') {
    document.querySelectorAll('.product-page__props').forEach(function (elem) {
      elem.classList.add('hidden');
    });
  }
}

/***/ }),

/***/ "./src/js/product/sticky-form.js":
/*!***************************************!*\
  !*** ./src/js/product/sticky-form.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = stickyForm;
function stickyForm() {
  var stickyBox = document.querySelector('.product-sticky-form');
  var addStickyForm = function stickyScrollFunc() {
    var y = window.scrollY;
    if (y >= 700) {
      stickyBox.classList.add('show');
    } else {
      stickyBox.classList.remove('show');
    }
  };
  window.addEventListener('scroll', addStickyForm);
}

/***/ }),

/***/ "./src/js/product/vdb-redirect.js":
/*!****************************************!*\
  !*** ./src/js/product/vdb-redirect.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = vdbRedirect;
function vdbRedirect() {
  // eslint-disable-next-line no-undef
  if (vendorType.toLowerCase() === 'vdb') {
    window.location.href = '/cart';
  }
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!***************************!*\
  !*** ./src/js/product.js ***!
  \***************************/


var _vdbRedirect = _interopRequireDefault(__webpack_require__(/*! ./product/vdb-redirect */ "./src/js/product/vdb-redirect.js"));
var _bangleRedirect = _interopRequireDefault(__webpack_require__(/*! ./product/bangleRedirect */ "./src/js/product/bangleRedirect.js"));
var _productCarousel = _interopRequireDefault(__webpack_require__(/*! ./product/product-carousel */ "./src/js/product/product-carousel.js"));
var _modalTriggers = _interopRequireDefault(__webpack_require__(/*! ./product/modal-triggers */ "./src/js/product/modal-triggers.js"));
var _stickyForm = _interopRequireDefault(__webpack_require__(/*! ./product/sticky-form */ "./src/js/product/sticky-form.js"));
var _addToWishlist = _interopRequireDefault(__webpack_require__(/*! ./product/add-to-wishlist */ "./src/js/product/add-to-wishlist.js"));
var _klaviyoForm = _interopRequireDefault(__webpack_require__(/*! ./product/klaviyo-form */ "./src/js/product/klaviyo-form.js"));
var _globoRecommendations = _interopRequireDefault(__webpack_require__(/*! ./product/globo-recommendations */ "./src/js/product/globo-recommendations.js"));
var _removeUspFromHandbags = _interopRequireDefault(__webpack_require__(/*! ./product/remove-usp-from-handbags */ "./src/js/product/remove-usp-from-handbags.js"));
var _imagePanZoom = _interopRequireDefault(__webpack_require__(/*! ./product/imagePanZoom */ "./src/js/product/imagePanZoom.js"));
var _bangleCustomizer = _interopRequireDefault(__webpack_require__(/*! ./product/bangleCustomizer */ "./src/js/product/bangleCustomizer.js"));
var _customVariantImageSwap = _interopRequireDefault(__webpack_require__(/*! ./product/customVariantImageSwap */ "./src/js/product/customVariantImageSwap.js"));
var _breadReplacement = _interopRequireDefault(__webpack_require__(/*! ./product/bread-replacement */ "./src/js/product/bread-replacement.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(0, _vdbRedirect.default)();
(0, _bangleRedirect.default)();
(0, _productCarousel.default)();
(0, _modalTriggers.default)();
(0, _stickyForm.default)();
(0, _addToWishlist.default)();
(0, _klaviyoForm.default)();
(0, _globoRecommendations.default)();
(0, _removeUspFromHandbags.default)();
(0, _imagePanZoom.default)();
(0, _bangleCustomizer.default)();
(0, _customVariantImageSwap.default)();
(0, _breadReplacement.default)();
})();

/******/ })()
;

/* Change price and image when variant is selected */
document.addEventListener("DOMContentLoaded", function(){
    var variantIDs = document.querySelectorAll('[id^="selectvariant-"]');

    for (let i = 0; i < variantIDs.length; i++) {
      variantIDs[i].addEventListener("change", function() {

        /* Get info from selected option */
        var variantSelect = document.getElementById(this.getAttribute("id"));
        var variantSelectedPrice = variantSelect.options[variantSelect.selectedIndex].dataset.price;
        var variantSelectedImage = variantSelect.options[variantSelect.selectedIndex].dataset.image;

        /* Update price display */
        var productPriceContainer = document.getElementById("price-main");
        var productPrice = productPriceContainer.getElementsByClassName("price-item--regular")[0];
        productPrice.innerText = variantSelectedPrice;

        /* Update image display */
        var productImageContainer = document.getElementsByClassName("main-image-container");
        for (var i = 0; i < productImageContainer.length; i++) {
          if(variantSelectedImage){
            productImageContainer[i].getElementsByClassName("current-image")[0].setAttribute("src", variantSelectedImage);
          }
        }

      });
    }
});
